import { Crud, HttpClient, httpClient } from 'lib/HttpClient';

class ScheduledTasksApi extends Crud {
    constructor(httpClient: HttpClient) {
        super(httpClient, import.meta.env.API_SERVER_URL, 'scheduledtasks');
    }
}

export const scheduledTasksApi = new ScheduledTasksApi(httpClient);
